import { createContext, useContext, useState } from "react";

const BrsrContext = createContext();

export const useBRSR = () => useContext(BrsrContext);

export const BRSRProvider = ({ children }) => {
  const [brsrId, setBrsrId] = useState(null);

  return (
    <BrsrContext.Provider value={{ brsrId, setBrsrId }}>
      {children}
    </BrsrContext.Provider>
  );
};
